import React from 'react';
import { useReveal } from '../lib/useReveal';
const PAIN_POINTS = ['Años sintiendo que el cuerpo te habla sin saber cómo interpretarlo', 'Síntomas que los médicos no explican y vos intuís que tienen origen emocional', 'Cursos sueltos que no conectan entre sí y te dejan con más dudas que respuestas', 'Sin protocolo de sesión claro para atender con seguridad desde el primer día', 'Querés acompañar a otros a sanar pero no tenés la estructura para animarte', 'Podés cobrar por esto pero no sabés cómo armar tu consultorio profesional'];
export function ProblemSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-222">
      <div className="container mx-auto max-w-3xl" data-id="element-223">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-224">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight text-[#eab308] text-center" data-id="element-225">
            ¿Cuánto tiempo más vas a postergar esto?
          </h2>

          <div className="space-y-4 text-lg text-gray-300 leading-relaxed text-center mb-8" data-id="element-226">
            <p data-id="element-227">
              Sentís el llamado de la biodescodificación hace tiempo. Tal vez
              años. Pero nunca encontraste una formación completa, seria y
              accesible en Argentina.
            </p>
            <p className="font-bold text-white text-xl" data-id="element-228">
              No es falta de vocación. Es falta de un sistema.
            </p>
          </div>
        </div>

        <div ref={ref2} className={`reveal space-y-3 mb-10 ${vis2 ? 'is-visible' : ''}`} data-id="element-229">
          {PAIN_POINTS.map((point, i) => <div key={i} className="flex items-start gap-3 bg-[#111111] p-4 rounded-lg border border-white/5" data-id="element-230">
              <span className="text-red-500 flex-shrink-0 mt-0.5" data-id="element-231">❌</span>
              <p className="text-gray-300 text-base sm:text-lg" data-id="element-232">{point}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-233">
          <p className="text-[#eab308] font-serif font-bold text-2xl md:text-3xl" data-id="element-234">
            ¿Y si este fuera el último día que postergás tu camino?
          </p>
        </div>
      </div>
    </section>;
}